import React from 'react';
import { gql, useMutation } from '@apollo/client';
import Modal from 'styled-react-modal';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Wrapper } from '../StyledComponents.js';
import { Button, Input } from '../StyledComponents.js';

const StyledModal = Modal.styled`
  margin-left: auto;
  margin-right: auto;
  margin-top: 1em;
  background-color: white;
  border: .5em;
  border-style: solid;
  border-color: gray;
  padding: 1em;
  width: 85vw;
  @media(min-width: 960px) {
    width: 70vw;
  }
`;
const Row = styled.div`
  position: relative;
  margin-top: 1em;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  @media(min-width: 960px) {
    width: 50%;
  }
`;
const FormButton = styled(Button)`
    font-family: NeueEinstellungBold;
    text-align: center;
    white-space: nowrap;
    line-height: 1.5;
    font-size: 1.6rem;
    background-color: rgb(139, 125, 101);
    border: 0.1rem solid rgb(139, 125, 101);
    color: white;
    outline: 0px;
    display: block;
    font-weight: 500;
    width: 100%;
`;
const FormInput = styled(Input)`
    font-family: NeueEinstellungRegular;
    padding: 1.6rem 1.2rem;
    width: 100%;
    outline: 0px;
    border: 0.1rem solid rgb(221, 221, 221);
    border-radius: 0px;
    font-size: 1.6rem;
    appearance: none;
    box-sizing: border-box;
`;
const ErrorDiv = styled.div`
    font-family: NeueEinstellungRegular;
    font-size: 1rem;
    line-height: 1;
    padding: 1rem;
    position: relative;
    margin-bottom: 1rem;
    color: rgb(219, 41, 41);
    border: 0.1rem solid rgb(219, 41, 41);
`;

const REQUEST_PASSWORD_RESET = gql`
  mutation requestPasswordReset($email: String!) {
    requestPasswordReset(email: $email)
  }
`;

export default function ForgotPasswordModal({ isOpen, onClose }) {
  const [email, setEmail] = React.useState("");
  const [sent, setSent] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [requestReset, { loading }] = useMutation(REQUEST_PASSWORD_RESET, {
    onCompleted: () => setSent(true),
    onError: (e) => setError(e.message)
  });
  return (
    <StyledModal isOpen={isOpen} onEscapeKeydown={onClose} onBackgroundClick={onClose}>
      <Wrapper>
        <h1 className="text-center">
            <FormattedMessage id="login.forgot_password" defaultMessage="Forgot Password?" />
        </h1>
        {sent ? (
          <p><FormattedMessage id="login.reset_email_sent" defaultMessage="If the email exists, a reset link has been sent." /></p>
        ) : (
          <>
            {error && <ErrorDiv>{error}</ErrorDiv>}
            <Row>
              <FormInput type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="E-mail" />
            </Row>
            <Row>
              <FormButton onClick={() => requestReset({ variables: { email } })} disabled={loading}>
                <FormattedMessage id="login.send_reset" defaultMessage="Send Reset Link" />
              </FormButton>
            </Row>
          </>
        )}
        <Row>
          <FormButton onClick={onClose}>
            <FormattedMessage id={sent ? "login.back_to_login" : "login.cancel"} defaultMessage={sent ? "Back to Login" : "Cancel"} />
          </FormButton>
        </Row>
      </Wrapper>
    </StyledModal>
  );
}
